import axios from "axios";

const baseURL = {
  local: 'http://localhost:3000/dev',
  development: 'https://survey-service-dev.boomitra.com',
  production: 'https://survey-service.boomitra.com'
};

export default axios.create({ 
  baseURL: baseURL[process.env.REACT_APP_ENV || 'production'],
  headers: {
    'app': 'ADMIN'
  }
});
